shadow$provide[708] = function(global,require,module,exports) {
// Copypasted from:
// https://github.com/JedWatson/react-select/blob/1bbbc47f5bdd3bd81f6b95ada5554cdb8578ced5/packages/react-select/src/utils.ts
// MIT License

// ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
    return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function getScrollTop(el) {
    if (isDocumentElement(el)) {
        return window.pageYOffset;
    }

    return el.scrollTop;
}
function scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if (isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }

    el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;

    for (var parent = element; parent = parent.parentElement;) {
        style = getComputedStyle(parent);

        if (excludeStaticParent && style.position === 'static') {
            continue;
        }

        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
            return parent;
        }
    }

    return document.documentElement;
} // Animated Scroll To
// ------------------------------

/**
 @param t: time (elapsed)
 @param b: initial value
 @param c: amount of change
 @param d: duration
 */

function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
    var start = getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;

    function animateScroll() {
        currentTime += increment;
        var val = easeOutCubic(currentTime, start, change, duration);
        scrollTo(element, val);

        if (currentTime < duration) {
            window.requestAnimationFrame(animateScroll);
        } else {
            callback(element);
        }
    }

    animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;

    if (focusedRect.bottom + overScroll > menuRect.bottom) {
        scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    } else if (focusedRect.top - overScroll < menuRect.top) {
        scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
}

module.exports = {
    scrollIntoView: scrollIntoView
}
};